import React, { useState } from "react";
import "./HotelWebsite2.css";

const HotelWebsite2 = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [search, setSearch] = useState("");
  const [showEnquiry, setShowEnquiry] = useState(false);

  // --- 30 UNIQUE HOTEL PROPERTIES ---
  const hotelData = [
    { id: 1, name: "The Nomad Forest", loc: "Norway", price: "22,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1510798831971-661eb04b3739?auto=format&fit=crop&w=800" },
    { id: 2, name: "Concrete Oasis", loc: "Berlin", price: "14,500", cat: "Urban", img: "https://images.unsplash.com/photo-1551133990-7ccc23980f16?auto=format&fit=crop&w=800" },
    { id: 3, name: "Azure Cliffside", loc: "Greece", price: "35,000", cat: "Beach", img: "https://images.unsplash.com/photo-1515404929826-76fff9fef204?auto=format&fit=crop&w=800" },
    { id: 4, name: "Golden Sand Villas", loc: "Maldives", price: "85,000", cat: "Resort", img: "https://images.unsplash.com/photo-1506929196901-d6273969322d?auto=format&fit=crop&w=800" },
    { id: 5, name: "Industrial Loft", loc: "London", price: "12,000", cat: "Urban", img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=800" },
    { id: 6, name: "The Zen Garden", loc: "Kyoto", price: "28,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=800" },
    { id: 7, name: "Alpine Glass House", loc: "Swiss Alps", price: "45,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800" },
    { id: 8, name: "Desert Rose Inn", loc: "Morocco", price: "19,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=800" },
    { id: 9, name: "Harbor Lights", loc: "Sydney", price: "16,500", cat: "Urban", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800" },
    { id: 10, name: "Bamboo Sanctuary", loc: "Bali", price: "11,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800" },
    { id: 11, name: "The Palazzo", loc: "Rome", price: "32,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1551882547-ff43c63fedfe?auto=format&fit=crop&w=800" },
    { id: 12, name: "Modernist Palms", loc: "Dubai", price: "25,000", cat: "Resort", img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800" },
    { id: 13, name: "Retro Beach Club", loc: "Miami", price: "15,000", cat: "Beach", img: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?auto=format&fit=crop&w=800" },
    { id: 14, name: "Icelandic Cabin", loc: "Iceland", price: "21,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1476610182048-b716b8518aae?auto=format&fit=crop&w=800" },
    { id: 15, name: "Tokyo Neon Hotel", loc: "Tokyo", price: "13,000", cat: "Urban", img: "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?auto=format&fit=crop&w=800" },
    { id: 16, name: "Safari Glamping", loc: "Kenya", price: "38,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&w=800" },
    { id: 17, name: "Grand Paris Stay", loc: "France", price: "40,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800" },
    { id: 18, name: "The Surf Shack", loc: "Costa Rica", price: "9,000", cat: "Beach", img: "https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?auto=format&fit=crop&w=800" },
    { id: 19, name: "Himalayan Peak", loc: "Nepal", price: "12,500", cat: "Boutique", img: "https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=800" },
    { id: 20, name: "Barcelona Arts", loc: "Spain", price: "18,500", cat: "Urban", img: "https://images.unsplash.com/photo-1583422409516-2895a77efded?auto=format&fit=crop&w=800" },
    { id: 21, name: "The Reef House", loc: "Australia", price: "27,000", cat: "Resort", img: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&w=800" },
    { id: 22, name: "Santorini White", loc: "Greece", price: "33,000", cat: "Beach", img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800" },
    { id: 23, name: "Cotswolds Manor", loc: "UK", price: "24,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=800" },
    { id: 24, name: "Cape Town View", loc: "South Africa", price: "15,500", cat: "Urban", img: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?auto=format&fit=crop&w=800" },
    { id: 25, name: "Mexican Hacienda", loc: "Mexico", price: "14,000", cat: "Boutique", img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800" },
    { id: 26, name: "Vietnam River", loc: "Vietnam", price: "8,500", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1528127220108-1558304b4b3c?auto=format&fit=crop&w=800" },
    { id: 27, name: "Istanbul Suites", loc: "Turkey", price: "12,000", cat: "Urban", img: "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a6b?auto=format&fit=crop&w=800" },
    { id: 28, name: "Phuket Luxury", loc: "Thailand", price: "30,000", cat: "Resort", img: "https://images.unsplash.com/photo-1583037189850-1921ae7c6c22?auto=format&fit=crop&w=800" },
    { id: 29, name: "Prague Old Town", loc: "Czech", price: "11,500", cat: "Boutique", img: "https://images.unsplash.com/photo-1592906209472-a36b1f3782ef?auto=format&fit=crop&w=800" },
    { id: 30, name: "Amazon Jungle", loc: "Brazil", price: "20,000", cat: "Eco-Lodge", img: "https://images.unsplash.com/photo-1588668214407-6ea9a6d8c272?auto=format&fit=crop&w=800" },
  ];

  const categories = ["All", "Resort", "Boutique", "Urban", "Eco-Lodge", "Beach"];

  const filtered = hotelData.filter(h => 
    (activeTab === "All" || h.cat === activeTab) &&
    (h.name.toLowerCase().includes(search.toLowerCase()) || h.loc.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="hotelwebsite2-container">
      {/* --- SIDE NAVIGATION --- */}
      <aside className="hotelwebsite2-sidebar">
        <div className="hotelwebsite2-logo">S<span>.</span>T<span>.</span>A<span>.</span>Y</div>
        <nav className="hotelwebsite2-side-nav">
          <button className="active">Discover</button>
          <button>Collections</button>
          <button>About</button>
          <button onClick={() => setShowEnquiry(true)} className="enquiry-trigger">Inquire</button>
        </nav>
        <div className="hotelwebsite2-social">IG / FB / TW</div>
      </aside>

      <main className="hotelwebsite2-main">
        {/* --- TOP HEADER --- */}
        <header className="hotelwebsite2-header">
          <div className="header-info">
            <h1>Fine Living <span>Everywhere.</span></h1>
            <p>Curating space for the modern traveler.</p>
          </div>
          <div className="header-search">
            <input 
              type="text" 
              placeholder="Search destination..." 
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </header>

        {/* --- CATEGORY SCROLLER --- */}
        <div className="hotelwebsite2-tabs">
          {categories.map(c => (
            <button 
              key={c} 
              className={activeTab === c ? "active" : ""} 
              onClick={() => setActiveTab(c)}
            >
              {c}
            </button>
          ))}
        </div>

        {/* --- ASYMMETRICAL GRID --- */}
        <section className="hotelwebsite2-gallery">
          {filtered.map((hotel, idx) => (
            <div 
              key={hotel.id} 
              className={`hotelwebsite2-item ${idx % 5 === 0 ? 'large' : ''} ${idx % 3 === 0 ? 'tall' : ''}`}
            >
              <div className="hotelwebsite2-img-box">
                <img src={hotel.img} alt={hotel.name} />
                <div className="hotelwebsite2-overlay">
                  <span className="hotelwebsite2-price">₹{hotel.price}</span>
                  <button onClick={() => setShowEnquiry(true)}>Reserve</button>
                </div>
              </div>
              <div className="hotelwebsite2-item-info">
                <h3>{hotel.name}</h3>
                <p>{hotel.loc} • {hotel.cat}</p>
              </div>
            </div>
          ))}
        </section>
      </main>

      {/* --- SLIDE-IN ENQUIRY --- */}
      {showEnquiry && (
        <div className="hotelwebsite2-modal-bg">
          <div className="hotelwebsite2-drawer">
            <button className="close-drawer" onClick={() => setShowEnquiry(false)}>✕</button>
            <h2>Stay With Us</h2>
            <p>Tell us your preferences and we'll craft the perfect stay.</p>
            <form className="hotelwebsite2-form" onSubmit={(e) => {e.preventDefault(); alert("Request Sent!"); setShowEnquiry(false)}}>
              <input type="text" placeholder="Name" required />
              <input type="email" placeholder="Email" required />
              <div className="row">
                <input type="date" placeholder="Check In" required />
                <input type="number" placeholder="Guests" required />
              </div>
              <textarea placeholder="Special requests..."></textarea>
              <button type="submit">Submit Inquiry</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelWebsite2;